// ============================================
// NUMEROALETRAS.JS — Importe en letra para documentos (cotizacion PDF)
// ============================================
// "27699.11" -> "Veintisiete mil seiscientos noventa y nueve pesos 11/100 M.N."
// Reglas del espanol de Mexico para documentos fiscales/comerciales:
//  - 1 -> "Un peso"; 21 -> "Veintiun pesos"; 100 -> "Cien"; 101 -> "Ciento un";
//  - 1000 -> "Mil" (no "un mil"); 1001 -> "Mil un"; 21000 -> "Veintiun mil";
//  - 1,000,000 -> "Un millon"; 2,000,000 -> "Dos millones"; 1,000,000,000 -> "Mil millones".
//  - Centavos siempre como NN/100. MXN -> "pesos ... M.N."; USD -> "dolares ... USD".
// Sin dependencias. Puro. Se prueba con scripts/test-numero-a-letras.js (Node).

const UNIDADES = ['', 'un', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve', 'diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete', 'dieciocho', 'diecinueve', 'veinte'];
const VEINTIS = ['veinte', 'veintiún', 'veintidós', 'veintitrés', 'veinticuatro', 'veinticinco', 'veintiséis', 'veintisiete', 'veintiocho', 'veintinueve'];
const DECENAS = ['', '', 'veinte', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'];
const CENTENAS = ['', 'ciento', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos', 'seiscientos', 'setecientos', 'ochocientos', 'novecientos'];

// 0..999 en letras (sin "cero"; el cero global se maneja arriba).
function cientos(n) {
  if (n === 0) return '';
  if (n === 100) return 'cien';
  const c = Math.floor(n / 100), r = n % 100;
  let s = c ? CENTENAS[c] : '';
  let d = '';
  if (r <= 20) d = UNIDADES[r];
  else if (r < 30) d = VEINTIS[r - 20];
  else { const dec = Math.floor(r / 10), u = r % 10; d = DECENAS[dec] + (u ? ' y ' + UNIDADES[u] : ''); }
  return [s, d].filter(Boolean).join(' ');
}

// 0..999,999 en letras.
function miles(n) {
  const m = Math.floor(n / 1000), r = n % 1000;
  let s = '';
  if (m === 1) s = 'mil';
  else if (m > 1) s = cientos(m) + ' mil';
  const rr = cientos(r);
  return [s, rr].filter(Boolean).join(' ');
}

// Entero >= 0 (hasta 999,999,999,999) en letras.
export function enteroALetras(n) {
  n = Math.floor(Math.abs(Number(n) || 0));
  if (n === 0) return 'cero';
  const millones = Math.floor(n / 1e6), resto = n % 1e6;
  let s = '';
  if (millones === 1) s = 'un millón';
  else if (millones > 1) s = miles(millones) + ' millones';
  const rr = miles(resto);
  return [s, rr].filter(Boolean).join(' ');
}

function capitalizar(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

// importe (number|string) + moneda ('MXN'|'USD') -> texto completo con centavos.
export function importeALetras(importe, moneda = 'MXN') {
  const v = Math.abs(Number(importe) || 0);
  // Centavos por redondeo a 2 decimales (evita 0.29 -> 28 por flotantes).
  const total = Math.round(v * 100);
  const entero = Math.floor(total / 100), cent = total % 100;
  const esUSD = String(moneda || 'MXN').toUpperCase() === 'USD';
  const letras = enteroALetras(entero);
  // "un" -> concordancia con la moneda (un peso / veintiún pesos): la palabra final "un" o "veintiún" se conserva.
  const unidad = esUSD ? (entero === 1 ? 'dólar' : 'dólares') : (entero === 1 ? 'peso' : 'pesos');
  // Millones exactos: "un millón de pesos" / "dos millones de pesos".
  const deMillon = /(millón|millones)$/.test(letras) ? ' de' : '';
  const centTxt = String(cent).padStart(2, '0') + '/100';
  return capitalizar(`${letras}${deMillon} ${unidad} ${centTxt} ${esUSD ? 'USD' : 'M.N.'}`);
}

export default importeALetras;
